import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { formatMoney } from '../lib/money'
import type { CostBillingOverview } from '../types'

interface Props { billing: CostBillingOverview; currency: string; locale: string }

/** Investor billing spec §7: budget items where the subcontractors billed more than the investor was billed. */
const BillingWarningsCard: React.FC<Props> = ({ billing, currency, locale }) => {
  const { t } = useTranslation()
  const money = (v: string) => formatMoney(v, { locale, currency, whole: true })
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{t('CostControl_billing_warnings_title')}</CardTitle>
        <p className="text-sm text-muted-foreground">{t('CostControl_billing_warning_count', { count: billing.warningCount })}</p>
      </CardHeader>
      <CardContent>
        {billing.warnings.length === 0 ? (
          <p className="py-2 text-sm text-muted-foreground">{t('CostControl_billing_warnings_empty')}</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t('CostControl_billing_col_code')}</TableHead>
                <TableHead>{t('CostControl_col_name')}</TableHead>
                <TableHead className="text-right">{t('CostControl_billing_investor_billed')}</TableHead>
                <TableHead className="text-right">{t('CostControl_billing_subcontractor_billed')}</TableHead>
                <TableHead className="text-right">{t('CostControl_billing_difference')}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {billing.warnings.map((w) => (
                <TableRow key={w.nodeId}>
                  <TableCell>{w.code}</TableCell>
                  <TableCell>{w.name}</TableCell>
                  <TableCell className="text-right tabular-nums">{money(w.investorBilled)}</TableCell>
                  <TableCell className="text-right tabular-nums">{money(w.subcontractorBilled)}</TableCell>
                  <TableCell className="text-right tabular-nums text-destructive">{money(w.difference)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  )
}
export default BillingWarningsCard
